var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5875 0.412476C19.2414 0.0663866 18.7502 -0.0738145 18.2736 0.037411C18.2715 0.0379121 18.2693 0.0384261 18.2671 0.0389657L2.56082 3.8828C1.05304 4.25178 0 5.59362 0 7.14589V9.21874C0 9.97394 0.598389 10.592 1.34597 10.6237L8.20824 11.7918L9.37629 18.654C9.40797 19.4016 10.0261 20 10.7812 20H12.8541C14.4064 20 15.7482 18.947 16.1172 17.4392L19.9611 1.73296C19.9616 1.73077 19.9621 1.72858 19.9626 1.72639C20.0738 1.24975 19.9336 0.758577 19.5875 0.412476ZM18.7458 1.44021L14.903 17.142C14.6713 18.0888 13.8288 18.75 12.8541 18.75H10.7812C10.6951 18.75 10.625 18.6799 10.625 18.5937C10.625 18.5586 10.622 18.5235 10.6161 18.4889L9.42033 11.4635L15.442 5.44189C15.6861 5.19783 15.6861 4.80209 15.442 4.55803C15.1979 4.31392 14.8021 4.31392 14.5581 4.55803L8.53647 10.5797L1.51114 9.38387C1.47649 9.37797 1.44141 9.37499 1.40625 9.37499C1.32007 9.37499 1.25 9.30491 1.25 9.21874V7.14589C1.25 6.17119 1.91121 5.32866 2.85798 5.09699L18.5598 1.2542C18.6285 1.23901 18.6759 1.26865 18.7036 1.29634C18.7314 1.32408 18.761 1.37147 18.7458 1.44021Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.d31e1bf33d8117ced03c5659fe3af07b.svg";
export { ForwardRef as ReactComponent };